const actions = {
  SET_ROLE: 'authorize/SET_ROLE'
};

export default actions;
